import { render, staticRenderFns } from "./reference-prices.vue?vue&type=template&id=01bbf664&scoped=true"
import script from "./reference-prices.vue?vue&type=script&lang=js"
export * from "./reference-prices.vue?vue&type=script&lang=js"
import style0 from "./reference-prices.vue?vue&type=style&index=0&id=01bbf664&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bbf664",
  null
  
)

export default component.exports